// extracted by mini-css-extract-plugin
module.exports = {"container":"DeliverySchedule_container__ivrKl","text":"DeliverySchedule_text__sJn3F","day":"DeliverySchedule_day__DiCJL"};